import { render } from "./MainLayout.vue?vue&type=template&id=6a3b06e7&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=6a3b06e7&scoped=true&lang=css"
import "./MainLayout.vue?vue&type=style&index=1&id=6a3b06e7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3b06e7"]])

export default __exports__